import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import { useMutation, gql } from '@apollo/client'
import { savePlatformFeesConfiguration } from '../../../apollo'
import { Box, Typography, Input, Button, Alert } from '@mui/material'
import useStyles from '../styles'
import useGlobalStyles from '../../../utils/globalStyles'

const SAVE_PLATFORM_FEES_CONFIGURATION = gql`
  ${savePlatformFeesConfiguration}
`

function PlatformFeesConfiguration(props) {
  const { t } = props
  const formRef = React.useRef()
  const platformFeesValue = props.platformFeesValue ?? ''

  const [mutate, { loading }] = useMutation(SAVE_PLATFORM_FEES_CONFIGURATION)

  const classes = useStyles()
  const globalClasses = useGlobalStyles()
  const [successMessage, setSuccessMessage] = useState('')
  const [errorMessage, setErrorMessage] = useState('')

  const handleSuccess = message => {
    setSuccessMessage(message)
  }

  const handleError = error => {
    setErrorMessage('An error occurred while saving configuration.')
    console.error('Mutation error:', error)
  }

  useEffect(() => {
    if (successMessage) {
      const timeoutId = setTimeout(() => {
        setSuccessMessage('')
      }, 3000)
      return () => clearTimeout(timeoutId)
    }
  }, [successMessage])

  useEffect(() => {
    if (errorMessage) {
      const timeoutId = setTimeout(() => {
        setErrorMessage('')
      }, 3000)
      return () => clearTimeout(timeoutId)
    }
  }, [errorMessage])

  const onSave = e => {
    e.preventDefault()
    const feesValueInput = formRef.current['input-platform-fees-value'].value
    const parseNullableNumber = value => {
      if (value === '' || value === null || typeof value === 'undefined') {
        return null
      }
      const parsed = Number(value)
      return Number.isNaN(parsed) ? null : parsed
    }
    if (!loading) {
      mutate({
        variables: {
          platformFeesValue: parseNullableNumber(feesValueInput)
        },
        onCompleted: data => {
          handleSuccess(t('Configuration saved successfully!'))
        },
        onError: error => {
          handleError(error)
        }
      })
    }
  }

  return (
    <Box container className={classes.container}>
      <Box className={classes.flexRow}>
        <Box item className={classes.heading}>
          <Typography variant="h6" className={classes.text}>
            {t('Platform Fee Configuration')}
          </Typography>
        </Box>
      </Box>

      <Box className={classes.form}>
        <form ref={formRef}>
          <Box>
            <Typography className={classes.labelText}>
              {t('Platform Fee (%)')}
            </Typography>
            <Typography
              variant="caption"
              style={{ color: '#666', marginBottom: 8, display: 'block' }}>
              {t('Service fee applied to orders')}
            </Typography>
            <Input
              style={{ marginTop: -1 }}
              id="input-platform-fees-value"
              name="input-platform-fees-value"
              placeholder={t('Platform Fee')}
              type="number"
              defaultValue={platformFeesValue}
              disableUnderline
              className={globalClasses.input}
            />
          </Box>
          <Box mt={2}>
            <Button
              className={globalClasses.button}
              disabled={loading}
              onClick={onSave}>
              {t('Save')}
            </Button>
          </Box>
          <Box mt={2}>
            {successMessage && (
              <Alert
                className={globalClasses.alertSuccess}
                variant="filled"
                severity="success">
                {successMessage}
              </Alert>
            )}
            {errorMessage && (
              <Alert
                className={globalClasses.alertError}
                variant="filled"
                severity="error">
                {errorMessage}
              </Alert>
            )}
          </Box>
        </form>
      </Box>
    </Box>
  )
}

export default withTranslation()(PlatformFeesConfiguration)
